import React from 'react';
import AttachmentsComponent from '../Elements/AttachmentsComponent';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import GeneralEntryLogFigma from '../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../Elements/CommentsEntryLogDescription';
import UserNameComponent from '../Elements/UserNameComponent';
import LevelComponent from '../Elements/LevelComponent';
import AssignmentListByClientUnitIdComponent from '../Contents/Operations/Locations/AssignmentListByClientUnitIdComponent';
import CountryText from '../Elements/CountryText';

export default class ClientUnitItem {
  constructor(item) {
    if (item === undefined) {
      this.SftpDataId = '';
      this.CuId = '';
      this.CuCcid = '';
      this.CuLasid = '';
      this.CuLdvid = '';
      this.CuSassieId = '';
      this.CuClientSassieId = '';
      this.CuName = '';
      this.CuAddress = '';
      this.CuAddress2 = '';
      this.CuCity = '';
      this.CuState = '';
      this.CuCountry = '';
      this.CuZipCode = '';
      this.CuAreaCode = '';
      this.CuPhone = '';
      this.CuContactLastName = '';
      this.CuContactFirstName = '';
      this.CuContactPrefix = '';
      this.CuContactTitle = '';
      this.CuContactEmail = '';
      this.CuContactFax = '';
      this.CuLdmid = '';
      this.CuDaysopen = '';
      this.CuHours = '';
      this.CuNameBill = '';
      this.CuAddressBill = '';
      this.CuAddress2Bill = '';
      this.CuCityBill = '';
      this.CuStateBill = '';
      this.CuZipCodeBill = '';
      this.CuCountryBill = '';
      this.CuPhoneBill = '';
      this.CuFaxBill = '';
      this.CuEmailBill = '';
      this.CuBillPayDays = '';
      this.CuBillSchedule = '';
      this.CuLdtidBill = '';
      this.CuRcyid = '';
      this.CuUsid = '';
      this.CuMod = '';
      this.CuUserLocId = '';
      this.CuGroupName = '';
      this.CuZipMatch = '';
      this.CuComp = '';
      this.CuYtdavg = '';
      this.CuEmailcomments = '';
      this.CuBilltounit = '';
      this.CuCoid = '';
      this.CuDeactivated = '';
      this.CuVat = '';
      this.CuBilladdresstype = '';
      this.CuBillToClientName = '';
      this.CuLevel1 = '';
      this.CuLevel2 = '';
      this.CuLevel3 = '';
      this.CuLevel4 = '';
      this.CuLevel5 = '';
      this.CuAdditId = '';
      this.CuGroupNameIndex = '';
      this.ClientName = '';
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.CftpDataId = item.CftpDataId;
    this.CuId = item.cuId;
    this.CuCcid = item.cuCcid;
    this.CuLasid = item.cuLasid;
    this.CuLdvid = item.cuLdvid;
    this.CuSassieId = item.cuSassieId;
    this.CuClientSassieId = item.cuClientSassieId;
    this.CuName = item.cuName;
    this.CuAddress = item.cuAddress;
    this.CuAddress2 = item.cuAddress2;
    this.CuCity = item.cuCity;
    this.CuState = item.cuState;
    this.CuCountry = item.cuCountry;
    this.CuZipCode = item.cuZipCode;
    this.CuAreaCode = item.cuAreaCode;
    this.CuPhone = item.cuPhone;
    this.CuContactLastName = item.cuContactLastName;
    this.CuContactFirstName = item.cuContactFirstName;
    this.CuContactPrefix = item.cuContactPrefix;
    this.CuContactTitle = item.cuContactTitle;
    this.CuContactEmail = item.cuContactEmail;
    this.CuContactFax = item.cuContactFax;
    this.CuLdmid = item.cuLdmid;
    this.CuDaysopen = item.cuDaysopen;
    this.CuHours = item.cuHours;
    this.CuNameBill = item.cuNameBill;
    this.CuAddressBill = item.cuAddressBill;
    this.CuAddress2Bill = item.cuAddress2Bill;
    this.CuCityBill = item.cuCityBill;
    this.CuStateBill = item.cuStateBill;
    this.CuZipCodeBill = item.cuZipCodeBill;
    this.CuCountryBill = item.cuCountryBill;
    this.CuPhoneBill = item.cuPhoneBill;
    this.CuFaxBill = item.cuFaxBill;
    this.CuEmailBill = item.cuEmailBill;
    this.CuBillPayDays = item.cuBillPayDays;
    this.CuBillSchedule = item.cuBillSchedule;
    this.CuLdtidBill = item.cuLdtidBill;
    this.CuRcyid = item.cuRcyid;
    this.CuUsid = item.cuUsid;
    this.CuMod = item.cuMod;
    this.CuUserLocId = item.cuUserLocId;
    this.CuGroupName = item.cuGroupName;
    this.CuZipMatch = item.cuZipMatch;
    this.CuComp = item.cuComp;
    this.cuYtdavg = item.cuYtdavg;
    this.CuEmailcomments = item.cuEmailcomments;
    this.CuBilltounit = item.cuBilltounit;
    this.CuCoid = item.cuCoid;
    this.CuDeactivated = item.cuDeactivated;
    this.CuVat = item.cuVat;
    this.CuBilladdresstype = item.cuBilladdresstype;
    this.CuBillToClientName = item.cuBillToClientName;
    this.CuLevel1 = item.cuLevel1;
    this.CuLevel2 = item.cuLevel2;
    this.CuLevel3 = item.cuLevel3;
    this.CuLevel4 = item.cuLevel4;
    this.CuLevel5 = item.cuLevel5;
    this.CuAdditId = item.cuAdditId;
    this.CuGroupNameIndex = item.CuGroupNameIndex;
    this.ClientName = item.clientName;
  }

  static NameOfTheIdField() {
    return 'CuId';
  }
  static nameOfTheItemDetailList() {
    return 'ClientUnit details';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CuMod'];

  static getAssignmentsCellContent(item) {
    return (
      <AssignmentListByClientUnitIdComponent
        clientUnitId={item.CuId}
        locationName={item.CuName}
      />
    );
  }

  static getAttachmentContent(item) {
    return (
      <AttachmentsComponent
        entityTypeId={24}
        entityId={item.CuId}
      />
    );
  }

  static getCommentsContent(item) {
    return (
      <GeneralEntryLogFigma
        description={CommentsEntryLogDescription}
        context={{ entityTypeId: 24, entityId: item.CuId }}
      />
    );
  }

  static BoolFields = ['IsActive', 'DeleteDownloadedFiles'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-users',
      data: [
        {
          name: 'CuName',
          label: 'Name',
          width: TabListTableCellWidthEnum.Double,
        },
        {
          name: 'CuContactLastName',
          label: 'Contact Last Name',
          width: TabListTableCellWidthEnum.Single,
        },
        {
          name: 'ClientName',
          label: 'Client Name',
          width: TabListTableCellWidthEnum.Double,
        },
        {
          name: (item) => <LevelComponent levelId={item.CuLevel1} />,
          label: 'Level 1',
          width: TabListTableCellWidthEnum.Single,
        },
        {
          name: 'CuContactLastName',
          label: 'Contact Last',
          width: TabListTableCellWidthEnum.Double,
        },
        {
          name: (item) => <LevelComponent levelId={item.CuLevel2} />,
          label: 'Level 2',
          width: TabListTableCellWidthEnum.Single,
        },
        {
          name: 'CuPhone',
          label: 'Phone',
          width: TabListTableCellWidthEnum.Double,
        },
        {
          name: (item) => <LevelComponent levelId={item.CuLevel3} />,
          label: 'Level 3',
          width: TabListTableCellWidthEnum.Single,
        },
        {
          name: 'CuUserLocId',
          label: 'Apollo Location ID',
          width: TabListTableCellWidthEnum.Double,
        },
        {
          name: (item) => <LevelComponent levelId={item.CuLevel4} />,
          label: 'Level 4',
          width: TabListTableCellWidthEnum.Single,
        },
        {
          name: 'CuSassieId',
          label: 'Apollo Database ID',
          width: TabListTableCellWidthEnum.Double,
        },
        {
          name: (item) => <LevelComponent levelId={item.CuLevel5} />,
          label: 'Level 5',
          width: TabListTableCellWidthEnum.Single,
        },
        {
          name: 'CuGroupName',
          label: 'Group',
          width: TabListTableCellWidthEnum.Double,
        },
        { name: '-message-', label: '' },
        {
          name: (item) => <UserNameComponent userId={item.CuUsid} />,
          label: 'Modified By',
        },
        { name: '', label: '' },
        { name: '', label: '' },
        { name: 'CuMod', label: 'Modified On' },
        { name: '', label: '' },
        { name: '', label: '' },
      ],
    },
    {
      tabName: 'Address',
      tabLabel: 'Address',
      icon: 'fa-solid fa-user-slash',
      data: [
        { name: (item) => ClientUnitItem.GetAddress(item), label: 'Address' },
        { name: 'CuCity', label: 'City' },
        { name: 'CuState', label: 'State' },
        { name: 'CuZipCode', label: 'Zip Code' },
        {
          name: (item) => <CountryText Code={item.CuCountry} />,
          label: 'Country',
        },
      ],
    },
    {
      tabName: 'Attachments',
      tabLabel: 'Attachments',
      icon: 'fa-solid fa-paperclip',
      data: [
        {
          name: ClientUnitItem.getAttachmentContent,
          label: 'Attachments',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-regular fa-comment',
      data: [
        {
          name: ClientUnitItem.getCommentsContent,
          label: 'Comments',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        {
          name: '-message-',
          label: 'The comments above are related to the primary user.',
        },
      ],
    },
    {
      tabName: 'Assignments',
      tabLabel: 'Assignments',
      icon: 'fa-solid fa-lightbulb-dollar',
      data: [
        {
          name: ClientUnitItem.getAssignmentsCellContent,
          label: 'Assignment',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Location Id',
        orderById: 'CuId',
        data: 'CuId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: 'Name',
        orderById: 'CuName',
        data: 'CuName',
        type: FieldTypesEnum.PureDataField /*FieldTypesEnum.DataFieldWithDetails*/,
        minWidth: 50,
      },
      {
        label: 'Country',
        orderById: 'CuCountry',
        data: (item) => <CountryText Code={item.CuCountry} />,
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'City',
        orderById: 'CuCity',
        data: 'CuCity',
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'State',
        orderById: 'CuState',
        data: 'CuState',
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'Phone',
        orderById: 'CuPhone',
        data: 'CuPhone',
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'Caspian Client ID',
        orderById: 'CuCcid',
        data: 'CuCcid',
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      // {label: "Actions", orderById: "", data:SftpDatumItem.getActionsContent,className:"text-center"},
    ];
  }

  static getActionsContent(item) {
    return null;
  }

  static GetAddress(item) {
    return `${item.CuAddress} ${item.CuAddress2}`;
  }

  static editFunction(id, item) {
    //this is just a placeholder
  }
}
